<!--Needed the <div class="content-background" for Pace app, as the current Pace background is grey -->
<!--After adding it doesn't effect Pace form for FI as the PFFI app background is already white.-->
<div class="content-background">
    @if (!isSideMenuDocbox) {
        <div class="modal-header p-3">
            <h3 class="modal-title" id="modal-title" translate="DOCBOX_TITLE"></h3>
        </div>
    }
    <ng-container *ngrxLet="docBox$; let docBox">
        <div class="modal-body p-3" id="modal-body">
            <fieldset [formGroup]="docBoxGroup">
                <div class="d-lg-none">
                    <pace-forms-docbox-filter-header
                        [docBox]="docBox"
                        [docBoxGroup]="docBoxGroup"
                        [enableIndividualDownload]="enableIndividualDownload"
                        (clearFilterAction)="clearFilter($event)"
                        (showUploadPopup)="showUploadPopup()"
                        (sortByFieldAction)="sortByField($event)"
                        (selectAllDocuments)="selectAllDocuments()"
                    ></pace-forms-docbox-filter-header>
                    @if (docBox.docBoxFiles.length > 0) {
                        <ng-container *ngrxLet="docBoxFiles$; let docBoxFiles">
                            @for (document of docBoxFiles; track document) {
                                @if (document.isFileVisible) {
                                    <pace-forms-docbox-document-row
                                        (uploadDocForEntry)="showUploadPopup($event)"
                                        [document]="document"
                                    ></pace-forms-docbox-document-row>
                                }
                            }
                        </ng-container>
                    }
                    @if (!docBox.isLoading && docBox.docBoxFiles.length === 0) {
                        <div
                            class="d-flex justify-content-center py-3"
                            translate="DOCBOX_NO_DOCUMENTS_TO_DISPLAY"
                        ></div>
                    }
                    @if (!docBox.isLoading) {
                        <a class="d-flex justify-content-center py-3" (click)="toggleDocBoxFiles()">{{
                            showMoreLessTranslation
                        }}</a>
                    }
                </div>
                <div class="row d-none d-lg-block">
                    <div class="col">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th translate="DOCBOX_TYPE_LABEL" (click)="sortByField('docType')">
                                        @if (docBox.sortByField.field === 'docType' && !docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (docBox.sortByField.field === 'docType' && docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_TITLE_LABEL" (click)="sortByField('title')">
                                        @if (docBox.sortByField.field === 'title' && !docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (docBox.sortByField.field === 'title' && docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_PRINT_NUMBER_LABEL" (click)="sortByField('printNumber')">
                                        @if (
                                            docBox.sortByField.field === 'printNumber' && !docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (
                                            docBox.sortByField.field === 'printNumber' && docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_DATE_LABEL" (click)="sortByField('date')">
                                        @if (docBox.sortByField.field === 'date' && !docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (docBox.sortByField.field === 'date' && docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_CREATED_BY_LABEL" (click)="sortByField('createdBy')">
                                        @if (
                                            docBox.sortByField.field === 'createdBy' && !docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (docBox.sortByField.field === 'createdBy' && docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_ORDER_NUMBER_LABEL" (click)="sortByField('orderNumber')">
                                        @if (
                                            docBox.sortByField.field === 'orderNumber' && !docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (
                                            docBox.sortByField.field === 'orderNumber' && docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_REPORT_STATUS_LABEL" (click)="sortByField('reportStatus')">
                                        @if (
                                            docBox.sortByField.field === 'reportStatus' && !docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (
                                            docBox.sortByField.field === 'reportStatus' && docBox.sortByField.ascending
                                        ) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th translate="DOCBOX_FILE_TYPE_LABEL" (click)="sortByField('fileType')">
                                        @if (docBox.sortByField.field === 'fileType' && !docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortDown"></fa-icon>
                                        }
                                        @if (docBox.sortByField.field === 'fileType' && docBox.sortByField.ascending) {
                                            <fa-icon [icon]="faSortUp"></fa-icon>
                                        }
                                    </th>
                                    <th
                                        class="docbox-action"
                                        [ngClass]="
                                            enableIndividualDownload
                                                ? 'docbox-upload-download-action'
                                                : 'docbox-download-action'
                                        "
                                    ></th>
                                </tr>
                                <tr class="search-input-row">
                                    <th class="select-column">
                                        <div class="checkbox-container">
                                            <input
                                                type="checkbox"
                                                class="form-control"
                                                #checkbox
                                                id="documents-select-all-docs-checkbox"
                                                formControlName="checkbox"
                                                (click)="selectAllDocuments()"
                                                [attr.aria-label]="'DOCBOX_SELECT_ALL_FILES' | translate"
                                            />
                                            @if (docBox.isAllFilesSelected) {
                                                <fa-icon
                                                    [icon]="faCheck"
                                                    size="2x"
                                                    (click)="checkbox.click()"
                                                ></fa-icon>
                                            }
                                        </div>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.docTypeInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.docType)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_DOCTYPE_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="docTypeInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.titleInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.title)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_TITLE_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="titleInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.printNumberInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.printNumber)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_PRINT_NUMBER_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="printNumberInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.dateInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.date)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_DATE_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="dateInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.createdByInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.createdBy)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_CREATED_BY_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="createdByInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.orderNumberInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.orderNumber)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_ORDER_NUMBER_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="orderNumberInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.reportStatusInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.reportStatus)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_REPORT_STATUS_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="reportStatusInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <span class="search-input">
                                            @if (docBoxGroup.controls.fileTypeInputControl.value) {
                                                <button
                                                    class="btn btn-link btn-sm clear-search-button"
                                                    (click)="clearFilter(filters.fileType)"
                                                    [attr.aria-label]="
                                                        'DOCBOX_CLEAR_FILE_TYPE_FILTER_ARIA_LABEL' | translate
                                                    "
                                                >
                                                    X
                                                </button>
                                            }
                                            <div class="text-input">
                                                <input
                                                    type="text"
                                                    formControlName="fileTypeInputControl"
                                                    class="search-input"
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </span>
                                    </th>
                                    <th>
                                        <button
                                            class="btn btn-small btn-secondary docbox-upload-new-file"
                                            #tooltip="bs-tooltip"
                                            [tooltip]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
                                            (click)="showUploadPopup()"
                                            [disabled]="isSideMenuDocbox"
                                        >
                                            <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                @if (docBox.docBoxFiles.length > 0) {
                                    <ng-container *ngrxLet="docBoxFiles$; let docBoxFiles">
                                        @for (document of docBoxFiles; track document) {
                                            @if (document.isFileVisible) {
                                                <tr
                                                    pace-forms-document-list-entry
                                                    (uploadDocForEntry)="showUploadPopup($event)"
                                                    [document]="document"
                                                ></tr>
                                            }
                                        }
                                    </ng-container>
                                }
                            </tbody>
                        </table>
                        @if (!docBox.isLoading && docBox.docBoxFiles.length === 0) {
                            <div class="d-flex justify-content-center" translate="DOCBOX_NO_DOCUMENTS_TO_DISPLAY"></div>
                        }
                        @if (!docBox.isLoading) {
                            <a class="d-flex justify-content-center" (click)="toggleDocBoxFiles()">{{
                                showMoreLessTranslation
                            }}</a>
                        }
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="modal-footer bg-light p-3" [ngClass]="{ 'fixed-bottom': !isSideMenuDocbox }">
            @if (docBox.isLoading) {
                <progressbar [striped]="true" [value]="100" [animate]="true"></progressbar>
            }
            <!-- Large screen download button only -->
            <div class="d-none d-lg-block">
                @if (!docBox.isLoading) {
                    <button
                        class="btn btn-primary btn-lg"
                        [disabled]="disableDownloadButton$ | async"
                        (click)="downloadDocuments()"
                        translate="DOCBOX_DOWNLOAD_SELECTED_DOCUMENTS"
                    ></button>
                }
            </div>
            <div class="d-flex align-items-center gap-2 p-1 p-lg-0 w-100 d-lg-none" dropdown [dropup]="true">
                @if (!docBox.isLoading) {
                    <button
                        class="btn btn-primary btn-lg split-button px-0 me-auto flex-grow-1"
                        [disabled]="disableDownloadButton$ | async"
                        (click)="downloadDocuments()"
                        translate="DOCBOX_DOWNLOAD_SELECTED_DOCUMENTS"
                    ></button>
                }

                <button
                    class="more-toggler btn btn-secondary btn-lg"
                    id="button-toggler"
                    dropdownToggle
                    [attr.aria-label]="'DOCBOX_ACTIONS_MENU_ARIA_LABEL' | translate"
                >
                    <fa-icon [icon]="faEllipsisV"></fa-icon>
                </button>

                <ul class="dropdown-menu dropdown-menu-end actionbar-dropdown w-100" *dropdownMenu>
                    <li
                        role="menuitem"
                        class="d-flex align-items-center w-100 p-1 btn-lg py-2 px-3"
                        (click)="$event.stopPropagation(); selectAllDocuments()"
                    >
                        <div class="checkbox-container">
                            <input
                                type="checkbox"
                                class="form-control me-2"
                                #checkbox
                                id="documents-select-all-checkbox"
                                formControlName="checkbox"
                                [attr.aria-label]="'DOCBOX_SELECT_ALL_FILES' | translate"
                            />
                            @if (docBox.isAllFilesSelected) {
                                <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                            }
                        </div>
                        <span class="ms-2" [translate]="'DOCBOX_SELECT_ALL_FILES'"></span>
                    </li>
                    <li role="menuitem" class="p-1 w-100 btn-lg w-100 py-2 px-3">
                        <button
                            class="btn btn-secondary"
                            #tooltip="bs-tooltip"
                            [tooltip]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
                            (click)="showUploadPopup()"
                            [disabled]="isSideMenuDocbox"
                            [attr.aria-label]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
                        >
                            <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
                            <span class="ms-2" [translate]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP'"></span>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>
</div>
